import { render, staticRenderFns } from "./add-message.vue?vue&type=template&id=ba415122&scoped=true"
import script from "./add-message.vue?vue&type=script&lang=ts"
export * from "./add-message.vue?vue&type=script&lang=ts"
import style0 from "./add-message.vue?vue&type=style&index=0&id=ba415122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba415122",
  null
  
)

export default component.exports